import React, { useCallback, FC } from 'react';
import { useTranslate } from 'react-admin';
import { makeStyles } from '@material-ui/core/styles';
import { time } from '~/utils';
import { Moment } from '~/types';
import usePath from '~/hooks/usePath';
import { debounce, set as lodashSet } from 'lodash';
import { SelectInput } from 'react-admin';
import { Filter } from 'react-admin';
import { DateTimeInput } from '../ra';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    alignItems: 'flex-end',
    paddingBottom: theme.spacing(2),
  },
  filters: {
    alignItems: 'flex-start',
    '& > div': {
      '& > div:last-child': {
        width: 0,
      },
    },
  },
  formControl: {
    marginRight: theme.spacing(1),
    width: 180,
    '&:last-child': {
      marginRight: 0,
    },
  },
  datePickers: {
    marginRight: theme.spacing(1),
    marginTop: 0,
    marginBottom: 0,
    minWidth: 170,
    maxWidth: 180,
    flexGrow: 1,
    '& > div': {
      paddingRight: 0,
      '& > div': {
        marginLeft: 0,
      },
    },
  },
}));

const Filters: FC<any> = (props) => {
  const { setFilters, filters } = props;
  const classes = useStyles();
  const translate = useTranslate();
  const t = (key: string) => translate(`components.Applications.filters.${key}`);
  const { changePath } = usePath();

  const handleDateTimeChange = (data: Moment, inputType: 'createdFrom' | 'createdTo') => {
    changePath({ page: 1 });
    debouncedSetFilters((prev: any) => {
      const isoData = time(data).toISOString();
      return { ...lodashSet(prev, inputType, isoData) };
    });
  };

  const debouncedSetFilters = useCallback(debounce(setFilters, 400), [setFilters]);
  const handleChange = (e: any) => {
    if (!e?.target) return null;
    const { name, value } = e.target;
    changePath({ page: 1 });
    debouncedSetFilters((prev: any) => {
      return { ...lodashSet(prev, name, value) };
    });
  };
  return (
    <div className={classes.container}>
      <Filter className={classes.filters} setFilters={() => null} hideFilter={() => null}>
        <DateTimeInput
          className={classes.formControl}
          source='createdFrom'
          label={t('createdFrom')}
          options={{ format: 'L - LT', clearable: true }}
          fullWidth
          alwaysOn
          initialValue={filters?.createdFrom}
          onChange={(date: any) => handleDateTimeChange(date as Moment, 'createdFrom')}
        />
        <DateTimeInput
          className={classes.formControl}
          source='createdTo'
          label={t('createdTo')}
          options={{ format: 'L LT', clearable: true }}
          fullWidth
          alwaysOn
          initialValue={filters?.createdTo}
          onChange={(date: any) => handleDateTimeChange(date as Moment, 'createdTo')}
        />
        <SelectInput
          name='status'
          source='status'
          label={t('status')}
          choices={[
            { id: 'IN_PROGRESS', name: t('IN_PROGRESS') },
            { id: 'COMPLETED', name: t('COMPLETED') },
            { id: 'TERMINATED', name: t('TERMINATED') },
          ]}
          onChange={handleChange}
          alwaysOn
          emptyText={translate('utils.any')}
          className={classes.formControl}
        />
      </Filter>
    </div>
  );
};

export default Filters;
